/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { Resource } from '@common/application/enums/Resource';
import { ResourceUrl } from '@common/application/helpers/generateSignedUrlsForResults';
import uploadFileToSignedUrl from '@common/application/helpers/uploadFileToSignedUrl';
import { ElasticQueryOpts, ElasticResponse, ElasticSort } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export class Help {
  id;
  companyId;
  locale;
  title;
  description;
  url: ResourceUrl;
  helpTypeId;
  embed;
  createdat;
  updatedat;
  deletedAt;

  constructor(companyId, locale, title, description, url: ResourceUrl, helpTypeId, embed) {
    this.companyId = companyId;
    this.locale = locale;
    this.title = title;
    this.description = description;
    this.url = url;
    this.helpTypeId = helpTypeId;
    this.embed = embed;
  }

  static list(query, sort, queryOpts: ElasticQueryOpts, size?: number, pit?: Nullable<string>, search_after?: Nullable<ElasticSort>): ElasticResponse<Help> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/help`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts),
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/help/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.post(`/api/v1/help/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(
    updatedHelp: {
      companyId: number;
      localeId: string;
      title: string;
      description: string;
      url: string;
      helpTypeId: string;
      embed: boolean;
    },
    id: number,
  ): Promise<Record<string, unknown>> {
    return axiosInstance.patch(`/api/v1/help/${id}`, { payload: updatedHelp }).then((res) => ({ ...res.data }));
  }

  add(ext: string, name: string): Promise<Record<string, unknown>> {
    return axiosInstance
      .post(`/api/v1/help`, {
        payload: {
          meta: {
            companyId: Number(this.companyId),
            localeId: this.locale,
            title: this.title,
            description: this.description,
            helpTypeId: this.helpTypeId,
            embed: this.embed,
          },
          file: { dataPresent: !!this.url, name: name },
          // name,
        },
      })
      .then(async (res) => {
        const { signedUrl } = res.data.payload;
        await uploadFileToSignedUrl(signedUrl, this.url.url as File, res.data.payload, 'url', Resource.HELP);
        return { ...res.data };
      });
  }
}
